import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { useRoute } from 'vue-router/composables';
import SModal from '@/components/SModal.vue';
import STextField from '@/components/STextField/STextField.vue';
import { isRequired } from '@/utils/rules';
import type { Location } from 'vue-router';
import SLabel from '@/components/SLabel.vue';

interface SaveSearchButtonEmits {
  (e: 'save', name: string, query: Location['query']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveSearchButton',
  emits: ["save"],
  setup(__props, { emit }) {


const route = useRoute();

const modal = _ref<InstanceType<typeof SModal> | null>(null);
let name = _ref('');
const isValid = _ref(false);
const handleCancel = () => {
  name.value = '';
};

const canSave = _computed(() => isValid.value && Object.keys(route.query).length > 0);

const handleSave = () => {
  emit('save', name.value, route.query);
  modal.value?.closeModal();
};

const openModal = () => {
  modal.value?.openModal();
};

return { __sfc: true,emit, route, modal, name, isValid, handleCancel, canSave, handleSave, openModal, _ref, _computed, useRoute, SModal, STextField, isRequired, SLabel }
}

})